'use client';

import { c as _c } from "react/compiler-runtime";
import type { GetAllCollectionsOutputDTO } from '@algoacademy/backend/modules/docs/endpoints/queries/get-all-collections/output.dto';
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { Link } from '@algoacademy/design-system/web/actions/Link';
import { TextDecorator } from '@algoacademy/design-system/web/atoms/TextDecorator';
import { H3 } from '@algoacademy/design-system/web/typography/Heading';
import { P2 } from '@algoacademy/design-system/web/typography/Paragraph';
import { ArrowLongRightIcon as ArrowRight } from '@heroicons/react/24/solid';
import { CollectionAccessPreview } from '@/app/baza/_components/CollectionAccessPreview';
import { getCollectionEntryHref } from '@/app/baza/_helpers/get-collection-entry-href';
export type CollectionGridCardProps = {
  collection: GetAllCollectionsOutputDTO['allCollections'][number];
  isManageCollectionCard?: boolean;
};
export function CollectionGridCard(t0) {
  const $ = _c(29);
  const {
    collection,
    isManageCollectionCard: t1
  } = t0;
  const isManageCollectionCard = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== collection) {
    t2 = getCollectionEntryHref(collection);
    $[0] = collection;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const entryHref = t2;
  const actionHref = isManageCollectionCard ? `/baza/${collection.slug}/manage` : entryHref;
  const actionLabel = isManageCollectionCard ? "Zarz\u0105dzaj kolekcj\u0105" : "Przejd\u017A do artyku\u0142\xF3w";
  let t3;
  if ($[2] !== collection.gradientColor || $[3] !== collection.name) {
    t3 = <TextDecorator gradientColor={collection.gradientColor}>{collection.name}</TextDecorator>;
    $[2] = collection.gradientColor;
    $[3] = collection.name;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== actionHref || $[6] !== t3) {
    t4 = <H3><Link href={actionHref} prefetch={true}>{t3}</Link></H3>;
    $[5] = actionHref;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== collection.description || $[9] !== collection.isPersonalWorkspace || $[10] !== isManageCollectionCard) {
    t5 = isManageCollectionCard && collection.isPersonalWorkspace ? <P2 className="text-contentTertiary">Prywatna kolekcja robocza tylko dla Ciebie.</P2> : <P2 className="text-contentTertiary">{collection.description}</P2>;
    $[8] = collection.description;
    $[9] = collection.isPersonalWorkspace;
    $[10] = isManageCollectionCard;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <div className="space-y-3">{t4}{t5}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== collection.assignedRoles || $[16] !== collection.assignedUsers || $[17] !== collection.isPersonalWorkspace || $[18] !== collection.isPublic || $[19] !== isManageCollectionCard) {
    t7 = isManageCollectionCard && !collection.isPersonalWorkspace && <CollectionAccessPreview assignedRoles={collection.assignedRoles} assignedUsers={collection.assignedUsers} isPublic={collection.isPublic} />;
    $[15] = collection.assignedRoles;
    $[16] = collection.assignedUsers;
    $[17] = collection.isPersonalWorkspace;
    $[18] = collection.isPublic;
    $[19] = isManageCollectionCard;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ArrowRight />;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== actionHref || $[23] !== actionLabel) {
    t9 = <Button plain={true} href={actionHref} prefetch={true} className="w-fit self-end font-normal">{actionLabel}{t8}</Button>;
    $[22] = actionHref;
    $[23] = actionLabel;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t6 || $[26] !== t7 || $[27] !== t9) {
    t10 = <div className="h-fit w-full max-w-md rounded-xl border border-borderPrimary bg-backgroundPrimary p-6 pb-4.5 shadow-md"><div className="flex flex-col justify-between gap-4">{t6}{t7}{t9}</div></div>;
    $[25] = t6;
    $[26] = t7;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
}